import React from "react";

/**
 * Refined editorial label rule — Davidoff-quiet.
 * Single thin gold line + uppercase mono label, no decorative diamond.
 */
export default function FolioRule({ label, className = "", tone = "gold" }) {
  const labelColor = tone === "gold" ? "text-gold/80" : tone === "tobacco" ? "text-tobacco/65" : "text-cream/65";
  const ruleClass = tone === "gold" ? "luxury-rule" : "h-px bg-current opacity-30";
  return (
    <div className={`flex items-center gap-6 ${className}`}>
      <div className={`flex-1 ${ruleClass}`} />
      {label ? (
        <div className={`font-mono text-[10px] tracking-widest2 uppercase ${labelColor}`}>{label}</div>
      ) : null}
      <div className={`flex-1 ${ruleClass}`} />
    </div>
  );
}
